import DsfAuditState from './auditState.vue'
import DsfStatsAuditFormulaForm from './formulaForm.vue'

const components = {
  DsfAuditState,
  DsfStatsAuditFormulaForm
}

function install(Vue) {
  Vue.config.performance = true;
  //按需引入element-ui组件
  Vue.prototype.$ELEMENT = {
    zIndex: 15000,
  };
  for (let key in components) {
    let it = components[key];
    Vue.component(it.name, it);
    if (!window.$components['platform']) {
      window.$components['platform'] = {}
    }
    window.$components['platform'][it.name] = it;
  }
}

export { install };
export default install;